import React, { useEffect, useState } from 'react';

const VariantSelector = ({ selectedProduct, selectedVariant, selectedOptions, handleChange, index, option_index, option, value }) => {
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    const isAvailable = Boolean(selectedProduct.variants.find(v => v.options.includes(value) && v.available))
    const otherSelectedOptions = Object.keys(selectedOptions).filter(o => o != option)

    if (!isAvailable) {
      setAvailable(false)
    } else if (otherSelectedOptions.length) {
      const hasAvailability = Boolean(selectedProduct.variants
        .filter(v => otherSelectedOptions.every(r => v[`option${selectedProduct.options.indexOf(r) + 1}`] == selectedOptions[r]))
        .filter(v => v.options.includes(value)).find(v => v.available))

      setAvailable(hasAvailability)
    }
  }, [selectedOptions])

  return (
    <label className={`option ${!available && 'is-unavailable'}`} key={`${selectedProduct.handle}-${value}`} value={value}>
      <input type="radio" value={value} data-index={`option${option_index + 1}`} id={`option-${option_index + 1}_${index + 1}`} name={option} onChange={handleChange} checked={selectedVariant[`option${option_index + 1}`] == value ? true : false}></input>
      <figure>
        <figcaption className="option_text">{value}</figcaption>
      </figure>
    </label>
  )
}
export default VariantSelector